<div class="container">
  <div class="admin-page-header">
    <h2 class="title admin-page-title">Payment Provider</h2>
    <div class="header-actions">
      <span class="summary-chip">Total: {{ totalElements }}</span>
      <button mat-stroked-button class="refresh-table-button" (click)="getPaymentProvider()">
        <mat-icon>refresh</mat-icon>
        Refrescar
      </button>
    </div>
  </div>

  <mat-card class="table-card">
    <app-data-table
      [dataSource]="paymentProviders"
      [displayedColumns]="displayedColumns"
      [loading]="loading"
      [emptyMessage]="'No hay registros de payment provider.'"
      [showPaginator]="true"
      [length]="totalElements"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[10, 25, 50]"
      [rowClickable]="true"
      (page)="onPageChange($event)"
      (rowClick)="setOpen($event.row)">
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let paymentProvider">{{ paymentProvider.status }}</td>
      </ng-container>

      <ng-container matColumnDef="provider">
        <th mat-header-cell *matHeaderCellDef>Provider</th>
        <td mat-cell *matCellDef="let paymentProvider">{{ paymentProvider.provider }}</td>
      </ng-container>

      <ng-container matColumnDef="phases">
        <th mat-header-cell *matHeaderCellDef>Phases</th>
        <td mat-cell *matCellDef="let paymentProvider">{{ paymentProvider.phases }}</td>
      </ng-container>

      <ng-container matColumnDef="currentPhase">
        <th mat-header-cell *matHeaderCellDef>Current Phase</th>
        <td mat-cell *matCellDef="let paymentProvider">{{ paymentProvider.currentPhase }}</td>
      </ng-container>

      <ng-container matColumnDef="paymentUuid">
        <th mat-header-cell *matHeaderCellDef>Payment UUID</th>
        <td mat-cell *matCellDef="let paymentProvider">{{ paymentProvider.paymentUuid }}</td>
      </ng-container>

      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef>Updated At</th>
        <td mat-cell *matCellDef="let paymentProvider">{{ paymentProvider.updatedAt | date: appService.FORMAT_DATETIME }}</td>
      </ng-container>
    </app-data-table>
  </mat-card>
</div>
